import React from "react";
import "../../styles/common/userDashboardComponents.scss";

const UserMetricCard = ({ title, done, total, icon: Icon, color = "blue" }) => {
  const percentage = total > 0 ? Math.round((done / total) * 100) : 0;
  const radius = 35;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (percentage / 100) * circumference;

  return (
    <div className={`user-metric-card ${color}`}>
      <div className="user-metric-left">
        <div className="user-metric-icon-wrap">
          {Icon && <Icon className="user-metric-icon" />}
        </div>
        <div className="user-metric-info">
          <div className="user-metric-title">{title}</div>
          <div className="user-metric-subtitle">COMPLETED</div>
          <div className="user-metric-stats">
            <div className="user-metric-stat">
              <strong>{done}</strong>
              <span>DONE</span>
            </div>
            <div className="user-metric-divider" />
            <div className="user-metric-stat">
              <strong>{total}</strong>
              <span>TOTAL</span>
            </div>
          </div>
        </div>
      </div>
      <div className="user-metric-right">
        <div className="user-metric-progress">
          <svg viewBox="0 0 100 100">
            <circle
              className="progress-bg"
              cx="50"
              cy="50"
              r={radius}
            />
            <circle
              className="progress-bar"
              cx="50"
              cy="50"
              r={radius}
              style={{
                strokeDasharray: circumference,
                strokeDashoffset: offset,
              }}
            />
          </svg>
          <div className="progress-text">{percentage}%</div>
        </div>
      </div>
    </div>
  );
};

export default UserMetricCard;
